
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/WorkflowStepTip/WorkflowStepTip.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./WorkflowStepTip.html');
        
        var script = require('./WorkflowStepTip.ts').default;
        module.exports = require('./WorkflowStepTip.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    